(() => {
  angular.module('app').component('hostInpatientClaimsDetailsClaimInfoComponent', {
    templateUrl: require('./claimInfo.component.html'),
    controller: InpatientClaimInfoController,
    controllerAs: 'vm',
    bindings: {
      claim: '<',
      patient: '<',
      currencyCode: '<',
    },
  });

  InpatientClaimInfoController.$inject = [
    '$state',
    '$scope',
    '$stateParams',
    '$uibModal',
    'abp.services.app.inpatientClaim',
    'abp.services.app.hostServiceRequest',
    'Hms.ServiceRequests.ServiceRequestType',
  ];

  function InpatientClaimInfoController(
    $state,
    $scope,
    $stateParams,
    $uibModal,
    inpatientClaimSvc,
    hostServiceRequestSvc,
    enumServiceRequestType
  ) {
    const vm = this;
    vm.loading = 0;
    vm.saving = 0;
    vm.timeZoneId = $stateParams.timeZoneId;
    vm.hasInpatientClaimProcessingEnhancement = abp.setting.getBoolean(
      'Hms.Feature.InpatientClaimProcessingEnhancement'
    );

    vm.enums = {};
    vm.enums.serviceRequestType = enumServiceRequestType;

    // TODO: Update permissions

    vm.permissions = {
      update: abp.auth.isGranted('GuaranteeLetters.Host.Update'),
      topUp: abp.auth.isGranted('GuaranteeLetters.Host.TopUp'),
      extend: abp.auth.isGranted('GuaranteeLetters.Host.Approve'),
    };

    vm.isEdit = false;

    vm.$onInit = init;
    vm.getFullDateTimeString = getFullDateTimeString;
    vm.pickUpRequestWithParams = pickUpRequestWithParams;

    function init() {}

    function getFullDateTimeString(date, timeZoneId) {
      return App.getFullDateTimeString(date, timeZoneId);
    }

    function pickUpRequestWithParams(redirectUrl, params) {
      vm.loading += 1;
      hostServiceRequestSvc
        .updateServiceRequestProcessorId({ id: vm.claim.serviceRequestId })
        .success(() => {})
        .finally(() => {
          vm.loading -= 1;
        });

      $state.go(redirectUrl, params);
    }
  }
})();
